import { GridDivider as GridDividerBase, GridDividerProps } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';

import { isString } from '~/util/string';

export const GridDivider = ({ title, ...props }: GridDividerProps) => {
  const { t } = useTranslation();
  return <GridDividerBase title={isString(title) ? t(title) : undefined} {...props} />;
};
